import React from 'react';
import './../styles/landing.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="container">
        <h1>About Us</h1>
        
        <section className="about-section">
          <h2>Our Story</h2>
          <p>
            At Record News, we blend the power of technology and media intelligence to transform print media monitoring into actionable insights. Leveraging the latest advancements in data analytics, machine learning, and Python programming, we provide businesses with deep, data-driven insights from print media sources—helping them make informed decisions with precision.            
          </p>
        </section>

        <section className="about-section">
          <h2>Why Choose Us?</h2>
          <p>
            We don’t just collect data—we decode it. By combining programmatic analysis with human expertise, we turn raw media content into clear, actionable intelligence that drives smarter business strategies.
            Whether you're a corporation, PR agency, or research firm, our technology ensures you stay ahead in an ever-evolving media landscape.
            Discover the future of media monitoring with Record News.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Expertise</h2>
          <p>
            Advanced Audio Media Monitoring: We track and analyze audio stations with unparalleled accuracy, ensuring you never miss a mention.
            AI-Powered Insights: Using Python-driven NLP (Natural Language Processing), Speech To Text and machine learning, we extract trends, sentiment, and key themes from media coverage.
            Customized Reporting: Our automated systems generate detailed, informative reports tailored to your industry, saving you time while delivering strategic value.
            Cutting-Edge Technology: From OCR (Optical Character Recognition) for digitized print media to predictive analytics, we stay ahead of the curve to give you a competitive edge.
          </p>
        </section>

        <section className="about-section">
          <h2>Why We’re Different</h2>
          <p>
            While others rely on outdated methods, we use Python scripting, predictive modeling, and big data processing to turn media noise into strategic foresight. Whether it’s crisis management, competitor benchmarking, or trend forecasting, we provide the speed and depth modern businesses demand.
            Stay informed. Stay ahead.
          </p>
        </section>

        <section className="team-section">
          <h2>Meet Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar"></div>
              <h3>John Doe</h3>
              <p>CEO & Founder</p>
            </div>
            <div className="team-member">
              <div className="member-avatar"></div>
              <h3>Jane Smith</h3>
              <p>CTO</p>
            </div>
            <div className="team-member">
              <div className="member-avatar"></div>
              <h3>Mike Johnson</h3>
              <p>Lead Developer</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
